export const FACILITIES_LEASING_READ_SCOPE = 'facilities:leasing:read';
export const FACILITIES_LEASING_WRITE_SCOPE = 'facilities:leasing:write';
export const FACILITIES_LEASING_ACTION_SCOPES = {
    workflowOperation: 'facilities:leasing:workflow',
    applicantAccess: 'facilities:leasing:applicant-access',
    documentReview: 'facilities:leasing:document-review',
    designReview: 'facilities:leasing:design-review',
    catalogManage: 'facilities:leasing:catalog-manage',
    commercialApprove: 'facilities:leasing:commercial-approve',
    financeDeposit: 'facilities:leasing:finance-deposit',
    contractPermit: 'facilities:leasing:contract-permit',
};
export const FACILITIES_LEASING_ACTION_SCOPE_VALUES = Object.values(FACILITIES_LEASING_ACTION_SCOPES);
/**
 * Billing owns lease-collections policy publication. These scopes are carried
 * only by the Facilities Admin audience because tenant-scoped Facilities
 * access control is the canonical staff-assignment boundary. They deliberately
 * do not join the general leasing-action family: collections policy authority
 * is a separate finance/legal governance concern, not a workflow permission.
 */
export const BILLING_LEASING_COLLECTIONS_POLICY_SCOPES = {
    author: 'billing:leasing:collections-policy:author',
    financeApprover: 'billing:leasing:collections-policy:finance-approve',
    legalApprover: 'billing:leasing:collections-policy:legal-approve',
    publisher: 'billing:leasing:collections-policy:publish',
};
export const BILLING_LEASING_COLLECTIONS_POLICY_SCOPE_VALUES = Object.values(BILLING_LEASING_COLLECTIONS_POLICY_SCOPES);
/**
 * These roles are tenant-assignable but protected: a broad Facilities leasing
 * administrator cannot grant, revoke, or self-assign collections governance
 * authority. Billing remains the domain owner through the role namespace.
 */
export const BILLING_LEASING_COLLECTIONS_POLICY_ROLES = {
    author: 'billing.leasing.collections-policy.author',
    financeApprover: 'billing.leasing.collections-policy.finance-approver',
    legalApprover: 'billing.leasing.collections-policy.legal-approver',
    publisher: 'billing.leasing.collections-policy.publisher',
};
export const BILLING_LEASING_COLLECTIONS_POLICY_ROLE_VALUES = Object.values(BILLING_LEASING_COLLECTIONS_POLICY_ROLES);
const BILLING_LEASING_COLLECTIONS_POLICY_ROLE_NAME_SET = new Set(BILLING_LEASING_COLLECTIONS_POLICY_ROLE_VALUES);
export function isBillingLeasingCollectionsPolicyRoleName(roleName) {
    return BILLING_LEASING_COLLECTIONS_POLICY_ROLE_NAME_SET.has(roleName);
}
export const FACILITIES_LEASING_FULL_ACCESS_ROLES = [
    'SYSTEM_ADMIN',
    'platform.superadmin',
    'facilities.admin',
    'facilities.leasing.admin',
];
export const FACILITIES_LEASING_VIEWER_ROLE = 'facilities.leasing.viewer';
/**
 * Deterministic, seed-owned automated probe identity role.
 *
 * It exists only so a login/health probe can obtain a `facilities-admin`
 * audience token and read leasing applications. It is deliberately excluded
 * from `FACILITIES_LEASING_FULL_ACCESS_ROLES`, from every leasing action-role
 * family, and from the tenant-assignable role catalog, so it can never acquire
 * configuration, pricing, user-management, or leasing write authority.
 */
export const FACILITIES_LEASING_SMOKE_ROLE = 'facilities.leasing.smoke';
/** Leasing roles that may read but must never mutate. */
export const FACILITIES_LEASING_READ_ONLY_ROLES = [
    FACILITIES_LEASING_VIEWER_ROLE,
    FACILITIES_LEASING_SMOKE_ROLE,
];
export const FACILITIES_LEASING_ACTION_ROLES = {
    workflowOperator: 'facilities.leasing.workflow.operator',
    applicantAccessManager: 'facilities.leasing.applicant-access.manager',
    documentReviewer: 'facilities.leasing.document-reviewer',
    designReviewer: 'facilities.leasing.design-reviewer',
    catalogManager: 'facilities.leasing.catalog-manager',
    commercialApprover: 'facilities.leasing.commercial-approver',
    financeDepositOperator: 'facilities.leasing.finance-deposit.operator',
    contractPermitOperator: 'facilities.leasing.contract-permit.operator',
};
export const FACILITIES_LEASING_ACTION_ROLE_VALUES = Object.values(FACILITIES_LEASING_ACTION_ROLES);
//# sourceMappingURL=facilities-leasing-policy.js.map